import { ofType } from 'redux-observable'
import { switchMap } from 'rxjs/operators'
import { from } from 'rxjs'
import { cookie } from 'devx-js-utilities'
import SettingsActions from '../Core/Redux/SettingsRedux'
import UserDataActions from '../Core/Redux/UserDataRedux'
import NavigationActions from '../Core/Redux/NavigationRedux'
import DebugActions from '../Core/Redux/DebugRedux'
import QuoteActions from '../Core/Redux/QuoteRedux'
import ProductActions from '../Core/Redux/ProductRedux'
import GeneralActions, { GeneralTypes } from '../Core/Redux/GeneralRedux'
import { getCurrentWebType, saveUtmParams } from '../helpers/general'
import { selectTrackingParams } from '../selectors/userData'
import passwords from '../Core/passwords.json'
import { selectIsAppRehydrated } from '../selectors/reduxPersist'
import { selectProductName } from '../selectors/product'

export default [
  (action$, state$) => {
    return action$.pipe(
      ofType(GeneralTypes.INIT_APP),
      switchMap(() => {
        const domain = cookie.readCookie('suriSite') || location.host
        const webType = getCurrentWebType(domain)

        const actions = [SettingsActions.onChangeWebType(webType), QuoteActions.resetFilters()]

        domain !== document.referrer.split('/')[2] && actions.push(NavigationActions.onSetReferrer(document.referrer))

        saveUtmParams(selectTrackingParams(state$.value))

        const debug = cookie.readCookie('suriDebug')
        debug && debug === passwords.debug && actions.push(DebugActions.onChangeDebugMode(true))

        const testing = cookie.readCookie('suriTesting')
        testing && testing === passwords.testing && actions.push(DebugActions.onChangeTestingMode(true))

        const subProductNameElement = document.getElementById('subProductName')
        const subProductName =
          subProductNameElement && subProductNameElement.value ? subProductNameElement.value : 'default'
        subProductName && actions.push(ProductActions.setSubProductName(subProductName))

        const isRehydrated = selectIsAppRehydrated(state$.value)
        const productName = selectProductName(state$.value)

        const fetchDependencies = isRehydrated
          ? [
              UserDataActions.defaultValuesRequestLoaderOff(productName, subProductName, false),
              ProductActions.productContentRequestLoaderOff(productName, false),
              ProductActions.productResourcesRequestLoaderOff(productName), // todo stahuje se navic na K1
              GeneralActions.onGetDefaultContentRequestLoaderOff(),
            ]
          : []
        return from([...actions, ...fetchDependencies])
      }),
    )
  },
]
